<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    max-width="80%">
    <v-card>
      <v-toolbar flat dark color="primary" style="max-height: 65px;">
        <v-btn icon dark class="hidden-md-and-up" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Neuer Kunde</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text :disabled="!customerForm.valid" v-show="$vuetify.breakpoint.sm" @click.native="createCustomer">
            Kunde anlegen
            <v-icon right>save</v-icon>
          </v-btn>
          <v-btn icon :disabled="!customerForm.valid" v-show="$vuetify.breakpoint.xs" @click.native="createCustomer">
            <v-icon>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="customerForm.valid">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-subheader class="title">Persönliche Daten</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="E-Mail"
                  v-model="customerForm.email"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-select
                  label="Anrede"
                  :items="salutations"
                  v-model="customerForm.salutation">
                </v-select>
              </v-flex>
              <v-flex xs9></v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="customerForm.firstName"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname/Firmenname"
                  v-model="customerForm.lastName"
                  :rules="mandatoryFieldRule"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Zusatz"
                  v-model="customerForm.addition"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Straße"
                  v-model="customerForm.street"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  label="Postleitzahl"
                  v-model="customerForm.zipCode"
                ></v-text-field>
              </v-flex>
              <v-flex xs9>
                <v-text-field
                  label="Stadt"
                  v-model="customerForm.city"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  label="Telefon-Nummer"
                  mask="###########################"
                  v-model="customerForm.phoneNumber"
                ></v-text-field>
              </v-flex>
              <v-flex xs9></v-flex>
              <v-flex xs3>
                <v-switch
                  v-model="customerForm.business"
                  label="Gewerblicher Kunde"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs9>
                <v-switch
                  v-model="customerForm.calculateVat"
                  label="Mehrwertsteuer berechnen"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Anfahrtsberechnung</v-subheader>
              </v-flex>
              <v-flex xs6 sm6 md3>
                <v-switch
                  v-model="customerForm.approachCharge"
                  label="Anfahrt berechnen"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs6 sm6 md3>
                <v-currency-field
                  :disabled="!customerForm.approachCharge"
                  label="Betrag pro Anfahrten"
                  v-model="customerForm.approachChargeValue"
                  v-bind="currencyConfig"
                >
                </v-currency-field>
              </v-flex>
              <v-flex xs6 sm6 md3>
                <v-switch
                  :disabled="!customerForm.approachCharge"
                  v-model="customerForm.fixDrives"
                  label="Feste Anzahl an Fahrten"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs6 sm6 md3>
                <v-text-field
                  :disabled="!(customerForm.fixDrives && customerForm.approachCharge)"
                  label="Anzahl Anfahrten"
                  v-model="customerForm.fixDrivesNumber"
                  type="number"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Anmerkungen zum Kunden</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  solo
                  name="instruction-input"
                  auto-grow
                  v-model="customerForm.internalInfos"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Mitarbeiterhinweis</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  solo
                  name="instruction-input"
                  auto-grow
                  v-model="customerForm.infos"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Mitarbeiter mit Anfahrtspauschale</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="users"
                  v-model="customerForm.fareUsers"
                  chips
                  deletable-chips
                  :item-value="userValue"
                  :item-text="userText"
                  return-object
                  label="Mitarbeiter eingeben"
                  multiple
                >
                  <template v-slot:append-item
                  >
                    <v-divider></v-divider>
                    <v-list-item
                      ripple
                      @click="loadNextEmployeePage"
                    >
                      <v-list-item-content>
                        <v-list-item-title>Weitere Mitarbeiter laden</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12>
                 <v-subheader class="title">Dienstleistungszuweisung</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="customerServiceDefinitions"
                  v-model="customerForm.customerServiceDefinitions"
                  chips
                  deletable-chips
                  :item-value="serviceValue"
                  :item-text="serviceText"
                  return-object
                  required
                  label="Dienstleistung suchen"
                  multiple
                >
                </v-select>
                <v-data-table
                  :headers="headers"
                  :items="customerForm.customerServiceDefinitions"
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-dialog v-model="dialog" max-width="900px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Dienstleistung bearbeiten</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.description" label="Beschreibung"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.extraLine1" label="Extrazeile 1"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.extraLine2" label="Extrazeile 2"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.extraLine3" label="Extrazeile 3"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-select :items="frequencies" v-model="editedItem.frequency" label="Abrechnungsrhythmus"></v-select>
                          </v-flex>
                          <v-flex xs3>
                            <v-switch v-model="editedItem.flatRate" label="Pauschale?" color="primary"></v-switch>
                          </v-flex>
                          <v-flex xs9>
                            <v-text-field v-model="editedItem.flatRateFee" label="Pauschalbetrag"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="closeDefinitionDialog">Abbrechen</v-btn>
                      <v-btn color="primary" text @click="saveDefinition">Speichern</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                  </template>
                  <template v-slot:item.frequency="{ item }">
                    {{getFrequencyRowText(item.frequency)}}
                  </template>
                  <template v-slot:item.flatRate="{ item }">
                    <v-icon
                      v-if="item.flatRate"
                      small
                      dark
                      color="primary"
                      class="mr-2"
                    >
                    check_circle
                    </v-icon>
                    <v-icon
                      v-else
                      small
                      dark
                      color="primary"
                      class="mr-2"
                    >
                    cancel
                    </v-icon>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      color="primary"
                      class="mr-2"
                      @click="edit(item)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      small
                      color="primary"
                      @click="remove(item)"
                    >
                      delete
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    Keine Auswahl
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Abbrechen</v-btn>
        <v-btn
          :disabled="!customerForm.valid"
          :loading="loading"
          color="primary"
          text
          @click.native="createCustomer">
          Kunde anlegen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import debounce from 'debounce'

  export default {
    name: 'NewCustomerDialog',
    props: ['show'],
    data () {
      return {
        page: 0,
        size: 50,
        dialog: false,
        customerForm: {
          valid: false,
          email: '',
          salutation: 'EMPTY',
          firstName: '',
          lastName: '',
          business: false,
          addition: '',
          approachCharge: false,
          approachChargeValue: '',
          fixDrives: false,
          fixDrivesNumber: 0,
          customerServiceDefinitions: [],
          fareUsers: [],
          street: '',
          city: '',
          zipCode: '',
          phoneNumber: '',
          infos: '',
          internalInfos: '',
          calculateVat: true
        },
        currencyConfig: {
          decimal: ',',
          thousands: '.',
          prefix: '€ ',
          precision: 2
        },
        headers: [
          {
            text: 'Dienstleistung',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Beschreibung',
            align: 'left',
            sortable: false,
            value: 'description'
          },
          {
            text: 'Extrazeile 1',
            align: 'left',
            sortable: false,
            value: 'extraLine1'
          },
          {
            text: 'Extrazeile 2',
            align: 'left',
            sortable: false,
            value: 'extraLine2'
          },
          {
            text: 'Extrazeile 3',
            align: 'left',
            sortable: false,
            value: 'extraLine3'
          },
          {
            text: 'Abrechnungsrhythmus',
            align: 'left',
            sortable: false,
            value: 'frequency'
          },
          {
            text: 'Pauschale?',
            align: 'left',
            sortable: false,
            value: 'flatRate'
          },
          {
            text: 'Pauschalbetrag',
            align: 'left',
            sortable: false,
            value: 'flatRateFee'
          },
          {
            text: 'Aktionen',
            align: 'left',
            sortable: false,
            value: 'action'
          }
        ],
        editedIndex: -1,
        editedItem: {
          service: {
            id: 0,
            name: ''
          },
          description: '',
          extraLine1: '',
          extraLine2: '',
          extraLine3: '',
          flatRate: false,
          flatRateFee: '0,00',
          frequency: 'HOURLY'
        },
        defaultItem: {
          service: {
            id: 0,
            name: ''
          },
          description: '',
          extraLine1: '',
          extraLine2: '',
          extraLine3: '',
          flatRate: false,
          flatRateFee: '0,00',
          frequency: 'HOURLY'
        },
        salutations: [
          {
            value: 'EMPTY',
            text: ''
          },
          {
            value: 'SIR',
            text: 'Herr'
          },
          {
            value: 'MADAM',
            text: 'Frau'
          },
          {
            value: 'FAMILY',
            text: 'Familie'
          },
          {
            value: 'COMPANY',
            text: 'Firma'
          }
        ],
        frequencies: [
          {
            value: 'HOURLY',
            text: 'Stündlich',
            disabled: false
          },
          {
            value: 'DAILY',
            text: 'Täglich',
            disabled: true
          },
          {
            value: 'MONTHLY',
            text: 'Monatlich',
            disabled: true
          }
        ],
        numberRule: [
          n => !!n || !isNaN(n) || 'Dieses Feld muss eine Zahl sein'
        ],
        salutationRule: [
          v => !!v || 'Bitte wählen sie eine Begrüßung aus'
        ],
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ],
        emailRules: [
          v => !!v || 'E-Mail nicht angegeben',
          v => /(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        ]
      }
    },
    computed: {
      loading: function () {
        return this.$store.getters.loading
      },
      users: function () {
        return this.$store.getters.allUsers
      },
      loadUsers: function () {
        return debounce(this.fetchUsers, 500)
      },
      customerServiceDefinitions: function () {
        const allServices = this.$store.getters.services
        return allServices.map(service => ({
          name: service.name,
          service: {
            id: service.id,
            name: service.name
          },
          description: '',
          extraLine1: '',
          extraLine2: '',
          extraLine3: '',
          flatRate: false,
          flatRateFee: '0,00',
          frequency: 'HOURLY'
        }))
      },
      editItemFlatRate: function () {
        return this.editedItem.flatRate
      }
    },
    watch: {
      editItemFlatRate (newFlatRate, oldFlatRate) {
        if (oldFlatRate && !newFlatRate) {
          this.frequencies.forEach(frequency => {
            if (frequency.value === 'HOURLY') {
              frequency.disabled = false
            } else {
              frequency.disabled = true
            }
          })
          this.editedItem.frequency = 'HOURLY'
        } else {
          this.frequencies.forEach(frequency => {
            if (frequency.value === 'HOURLY') {
              frequency.disabled = true
            } else {
              frequency.disabled = false
            }
          })
          if (this.editedItem.frequency === 'HOURLY') {
            this.editedItem.frequency = 'MONTHLY'
          }
        }
      }
    },
    created () {
      this.$store.dispatch('loadServices',
        {
          searchTerms: ''.split(' '),
          page: this.page,
          size: this.size
        })
    },
    methods: {
      createCustomer () {
        this.$store.dispatch('addCustomer', {
          email: this.customerForm.email,
          approachCharge: this.customerForm.approachCharge,
          approachChargeValue: this.mapToFloat(this.customerForm.approachChargeValue),
          fixDrives: this.customerForm.approachCharge && this.customerForm.fixDrives,
          fixDrivesNumber: this.getFixDrivesNumber(),
          customerServiceDefinitions: this.mapCustomerServiceDefinitions(this.customerForm.customerServiceDefinitions),
          fareUsers: this.customerForm.fareUsers,
          business: this.customerForm.business,
          addition: this.customerForm.addition,
          salutation: this.customerForm.salutation,
          firstName: this.customerForm.firstName,
          lastName: this.customerForm.lastName,
          street: this.customerForm.street,
          city: this.customerForm.city,
          zipCode: this.customerForm.zipCode,
          phoneNumber: this.customerForm.phoneNumber,
          infos: this.customerForm.infos,
          internalInfos: this.customerForm.internalInfos,
          calculateVat: this.customerForm.calculateVat
        })
          .then(() => this.$store.dispatch('showNotification', {
            title: 'Kunde erfolgreich geandert.',
            type: 'primary'
          }))
          .finally(() => this.close())
      },
      loadNextEmployeePage () {
        this.page++
        this.fetchUsers()
      },
      fetchUsers () {
        this.$store.dispatch('loadUsers', {
          searchTerms: ''.split(' '),
          page: this.page,
          size: this.size
        })
      },
      serviceValue (item) {
        return item.service.id
      },
      serviceText (item) {
        if (!Array.isArray(item)) {
          return item.service.name
        }
      },
      getFixDrivesNumber () {
        if (!this.customerForm.approachCharge || !this.customerForm.fixDrives) {
          return 0
        }
        return this.customerForm.fixDrivesNumber
      },
      textRateNameMapping (item) {
        return item.service.name
      },
      mapCustomerServiceDefinitions (definitions) {
        return definitions.map(definition => ({
          id: definition.id,
          service: {
            id: definition.service.id,
            name: definition.service.name
          },
          description: definition.description,
          extraLine1: definition.extraLine1,
          extraLine2: definition.extraLine2,
          extraLine3: definition.extraLine3,
          flatRate: definition.flatRate,
          flatRateFee: this.mapToFloat(definition.flatRateFee),
          frequency: definition.frequency
        }))
      },
      userValue (item) {
        if (Array.isArray(item)) {
          return item
        }
        return item.id
      },
      userText (item) {
        return item.lastName + ', ' + item.firstName
      },
      mapToFloat (nonFloatNumber) {
        if (isNaN(nonFloatNumber)) {
          return parseFloat(nonFloatNumber.replace(',', '.'))
        }
        return nonFloatNumber
      },
      toCurrencyString (flatRateFee) {
        if ((typeof flatRateFee) === 'string') {
          return flatRateFee
        }
        return flatRateFee.toFixed(2).replace('.', ',')
      },
      mapFlareUsers (users) {
        const usersArray = []

        users.forEach(user => {
          if (user.id) {
            usersArray.push(this.users.find(u => u.id === user.id))
          } else {
            usersArray.push(this.users.find(u => u.id === user))
          }
        })

        return usersArray
      },
      getFrequencyRowText (frequencyValue) {
        if (frequencyValue) {
          const frequency = this.frequencies.find(frequency => frequency.value === frequencyValue)
          return frequency.text
        }
      },
      edit (item) {
        this.editedIndex = this.customerForm.customerServiceDefinitions.findIndex(definition => definition.service.id === item.service.id)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      closeDefinitionDialog () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      saveDefinition () {
        if (this.editedIndex > -1) {
          Object.assign(this.customerForm.customerServiceDefinitions[this.editedIndex], this.editedItem)
        } else {
          this.customerForm.customerServiceDefinitions.push(this.editedItem)
        }
        this.closeDefinitionDialog()
      },
      remove (item) {
        const foundIndex = this.customerForm.customerServiceDefinitions.findIndex(definition => definition.service.id === item.service.id)
        if (foundIndex > -1) this.customerForm.customerServiceDefinitions.splice(foundIndex, 1)
      },
      removeUser (item) {
        const foundIndex = this.customerForm.fareUsers.indexOf(item)
        if (foundIndex > -1) this.customerForm.fareUsers.splice(foundIndex, 1)
      },
      close () {
        this.clearForm()
        this.$emit('close')
      },
      clearForm () {
        this.customerForm = initialState()
        this.$refs.form.reset()
      }
    }
  }

  function initialState () {
    return {
      valid: false,
      email: '',
      firstName: '',
      lastName: '',
      business: false,
      approachCharge: false,
      approachChargeValue: '',
      fixDrives: false,
      fixDrivesNumber: 0,
      textRate: false,
      customerServiceDefinitions: [],
      street: '',
      city: '',
      zipCode: '',
      phoneNumber: ''
    }
  }
</script>

<style scoped>
  .v-subheader {
    margin-left: -32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Customers/NewCustomerDialog.vue